import { useSelector } from "react-redux";
import { useCheckoutStateSelector } from "@checkout/context";
import { validatePointsInput } from "./validatePointsInput";
import { useRewardsCalculation } from "@/components/shared/RewardsSelection/hooks/useRewardsCalculation";
import { AccountSelectors } from "@/modules/account";
import { getRewardsAmountToApply } from "@/modules/checkout/states/Rewards/selectors";
import { getIsFixedPriceQuote } from "@/modules/flight-checkout/selectors";

export {
  PointsErrors,
  type PointsErrorValidationResult,
} from "./validatePointsInput";

export const usePointsInputValidator = () => {
  const minimumRedemptionPoints =
    useSelector(AccountSelectors.getMinimumRedemptionPoints) ?? 0;
  const rewardsAmountToApply = useCheckoutStateSelector(
    getRewardsAmountToApply
  );
  const { maxApplicablePoints } = useRewardsCalculation();
  const isFixedPrice = useCheckoutStateSelector(getIsFixedPriceQuote);

  return validatePointsInput(
    rewardsAmountToApply?.value,
    minimumRedemptionPoints,
    maxApplicablePoints?.totalPoints.value,
    isFixedPrice
  );
};
